/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Representation of a Price Range
 * @export
 * @interface PriceRange
 */
export interface PriceRange {
    /**
     * 
     * @type {Price}
     * @memberof PriceRange
     */
    maxPrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof PriceRange
     */
    minPrice?: Price;
}

/**
 * Check if a given object implements the PriceRange interface.
 */
export function instanceOfPriceRange(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PriceRangeFromJSON(json: any): PriceRange {
    return PriceRangeFromJSONTyped(json, false);
}

export function PriceRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maxPrice': !exists(json, 'maxPrice') ? undefined : PriceFromJSON(json['maxPrice']),
        'minPrice': !exists(json, 'minPrice') ? undefined : PriceFromJSON(json['minPrice']),
    };
}

export function PriceRangeToJSON(value?: PriceRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maxPrice': PriceToJSON(value.maxPrice),
        'minPrice': PriceToJSON(value.minPrice),
    };
}

